<script setup>
import {inject, onMounted, ref, watch} from "vue";
import CustomFieldValue from "@/components/customFields/CustomFieldValue.vue";
import CustomFieldEdit from "@/components/customFields/edit/CustomFieldEdit.vue";
import projectsService from "@/services/projects.service";

const project = inject('project');
const projectId = inject('trackerId');
const statusFieldsList = ref([]);
const addStatusFieldModal = ref(null);
const showFieldSelect = ref(false);

onMounted(() => {
    getAvailableStatusFields();
})

watch(() => project.projectStatusField, value => {
    if (value && value.id === -1) {
        project.projectStatusField = null;
        addStatusFieldModal.value.open(0);
    }
});

function fieldChanged() {
    project.projectStatusValue = null;
    showFieldSelect.value = false;
}

async function getAvailableStatusFields() {
    const {data} = await projectsService.getStatusesList();

    statusFieldsList.value = data;

    statusFieldsList.value.push({
        id: -1,
        name: "Create New Status",
    });

    if (!projectId.value && statusFieldsList.value.length) {
        project.projectStatusField = statusFieldsList.value[0];
    }
}

async function updateStatusField(id) {
    await getAvailableStatusFields();

    project.projectStatusField = statusFieldsList.value.find(item => item.id === id);
}

</script>

<template>
    <div>
        <h5 class="heading5 heading5--secondary">Project Status</h5>

        <div class="mb-4 mt-3">
            <div>
                <div class="mb-4 mb-sm-0" v-click-outside="() => {showFieldSelect = false}">
                    <div v-if="project.projectStatusField && !showFieldSelect" class="mb-1 d-flex">
                        <span>
                          {{project.projectStatusField.name}}
                        </span>

                        <div class="link-wrapper ml-2 pb-0">
                            <a
                                class="link-wrapper__edit text-nowrap"
                                @click.stop="showFieldSelect = true"
                            />
                        </div>
                    </div>

                    <select
                        v-else
                        v-model="project.projectStatusField"
                        class="selectbox selectbox-mid"
                        @change="fieldChanged"
                    >
                        <option :value="null">
                            Select field
                        </option>

                        <option v-for="(field, id) in statusFieldsList" :key="id" :value="field">
                            {{field.name}}
                        </option>
                    </select>
                        
                    <b-row v-if="project.projectStatusField && !showFieldSelect" class="form-control-wrapper">
                        <b-col cols="12" sm="7">
                            <CustomFieldValue
                                :field="project.projectStatusField"
                                :init-value="project.projectStatusValue"
                                :instantUpdate="false"
                                @valueChanged="(value) => project.projectStatusValue = value"
                            />
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>

        <CustomFieldEdit
            ref="addStatusFieldModal"
            type="project_status"
            @saved="updateStatusField"
        />
    </div>
</template>

<style scoped>

</style>
